/**
 * App Entry File
 */
/* eslint-disable */
import Vue from 'vue'
import Vuetify from 'vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import { Vue2Dragula } from 'vue2-dragula'
import VueBreadcrumbs from 'vue2-breadcrumbs'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
import AmAngularGauge from 'amcharts3/amcharts/gauge'
import VModal from 'vue-js-modal'
import Nprogress from 'nprogress'
import VueI18n from 'vue-i18n'
import fullscreen from 'vue-fullscreen'
//import InstantSearch from 'vue-instantsearch' // unused, removing, Bob
import $ from 'jquery';
import axios from 'axios'
import IdleVue from 'idle-vue'

// global components
import GlobalComponents from './globalComponents'

// app.vue
import App from './App'

// router
import router from './router'

// themes
import primaryTheme from './themes/primaryTheme';

// store
import { store } from './store/store';

// remove these modules from package.json
//import VueResource from 'vue-resource'

// include script file
import './lib/VuelyScript'

// include all css files
import './lib/VuelyCss'

// messages
import messages from './lang';

// Axios
var instance = axios.create({
    baseURL: config.coronerapiurl
    //baseURL: process.env.VUE_APP_CORONERAPIURL
    //baseURL: 'https://coronertestapi.gannettpeaktech.com/'
    //baseURL: 'http://localhost:49878/'
    //baseURL: 'https://api.wyocoroner.com'
})

instance.interceptors.request.use(function (config) {
    //loggingService.log(isDebug, 'main.js - (axios) request', 'url: ' + config.url)
	//console.log('HTTP request:', config.method.toUpperCase(), config.baseURL + config.url)
    store.commit('startHttpRunning')

    //check that the token is unexpired before any request
    var currentTime = (new Date).getTime()
    if (currentTime < JSON.parse(localStorage.getItem('expires_at'))) {
        config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('id_token')
    }
    return config
}, function (error) {
    //loggingService.log(true, 'main.js - (axios - shpo) request - error', error)

    return Promise.reject(error)
})

instance.interceptors.response.use(
  (response) => {
    store.commit('stopHttpRunning')
    return response
  },
  (error) => {
    store.commit('stopHttpRunning')
    console.log(error)

    const cfg = error.config || {}
    const resp = error.response || {}

    const url = cfg.baseURL && cfg.url
      ? cfg.url.replace(cfg.baseURL, '')
      : (cfg.url || 'N/A')

    const errorObject = {
      time: new Date().toLocaleString(),
      url,
      status: resp.status ? resp.status + ' - ' : '',
      message: error.message,
      stack: error.stack
    }

    store.commit('addError', errorObject)

    return Promise.reject(error)
  }
)


Vue.prototype.$http = instance
Vue.prototype.$httpRunning = false

// navigation guards before each
router.beforeEach((to, from, next) => {
	Nprogress.start()
	next()
})

// navigation guard after each
router.afterEach((to, from) => {
	Nprogress.done()
	setTimeout(() => {
		const contentWrapper = document.querySelector(".v-content__wrap");
		if(contentWrapper !== null){
			contentWrapper.scrollTop = 0;
		}
		const boxedLayout = document.querySelector('.app-boxed-layout .app-content');
		if(boxedLayout !==  null){
			boxedLayout.scrollTop = 0;
		}
		const miniLayout = document.querySelector('.app-mini-layout .app-content');
		if(miniLayout !== null){
			miniLayout.scrollTop = 0;
		}
	}, 200);
})

function toast({ title, message, type, timeout, cb }) {
	return miniToastr[type](message, title, timeout, cb)
}

const options = {
	success: toast,
	error: toast,
	info: toast,
	warn: toast
}

const toastTypes = {
	success: 'success',
	error: 'error',
	info: 'info',
	warn: 'warn'
}

miniToastr.init({ types: toastTypes })

// plugins
Vue.use(Vuetify, {
	//theme: store.getters.selectedTheme.theme
	theme: primaryTheme
});
// Vue.use(InstantSearch); - unused, removing, Bob
Vue.use(VueI18n)
Vue.use(AmCharts)
Vue.use(VModal)
Vue.use(AmSerial)
Vue.use(AmAngularGauge)
Vue.use(Vue2Dragula)
//Vue.use(VueResource)
Vue.use(VueBreadcrumbs)
Vue.use(VueNotifications, options)
Vue.use(fullscreen)
Vue.use(GlobalComponents)
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBtdO5k6CRntAMJCF-H5uZjTCoSGX95cdk' // Add your here your google map api key
	}
})

//Idle-vue
const eventsHub = new Vue()

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 3600000, // 60 minutes,
    startAtIdle: false
})

//Create VueI18n instance with options
const i18n = new VueI18n({
	locale: store.getters.selectedLocale.locale, // set locale
	messages, // set locale messages
})

/* eslint-disable no-new */
new Vue({
	store,
	i18n,
	router,
	render: h => h(App),
	components: { App }
}).$mount('#app')
